import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    state: null,
    options: {
        title: "",
        message: "",
        type: "success",
        duration: 1000,
        position: "top-center",
        closable: false,
    },
};

export const messageSlice = createSlice({
    name: "base/message",
    initialState,
    reducers: {
        showMessage: (state, action) => {
            state.state = true;
            state.options = {
                ...initialState.options,
                ...action.payload,
            };
        },
        hideMessage: (state, action) => {
            state.state = null;
        },
    },
});

export const { showMessage, hideMessage } = messageSlice.actions;

export const selectState = ({ base }) => base.message.state;

export const selectOptions = ({ base }) => base.message.options;

export default messageSlice.reducer;
